var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configureLayoutAnimations = configureLayoutAnimations;
exports.configureProps = configureProps;
Object.defineProperty(exports, "createWorkletRuntime", {
    enumerable: true,
    get: function get() {
        return _runtimes.createWorkletRuntime;
    }
});
exports.enableLayoutAnimations = enableLayoutAnimations;
exports.getViewProp = getViewProp;
exports.initializeSensor = initializeSensor;
exports.isReanimated3 = exports.isConfigured = void 0;
Object.defineProperty(exports, "makeMutable", {
    enumerable: true,
    get: function get() {
        return _mutables.makeMutable;
    }
});
Object.defineProperty(exports, "makeRemote", {
    enumerable: true,
    get: function get() {
        return _mutables.makeRemote;
    }
});
Object.defineProperty(exports, "makeShareable", {
    enumerable: true,
    get: function get() {
        return _shareables.makeShareable;
    }
});
Object.defineProperty(exports, "makeShareableCloneRecursive", {
    enumerable: true,
    get: function get() {
        return _shareables.makeShareableCloneRecursive;
    }
});
exports.registerEventHandler = registerEventHandler;
exports.registerSensor = registerSensor;
Object.defineProperty(exports, "runOnJS", {
    enumerable: true,
    get: function get() {
        return _threads.runOnJS;
    }
});
Object.defineProperty(exports, "runOnUI", {
    enumerable: true,
    get: function get() {
        return _threads.runOnUI;
    }
});
Object.defineProperty(exports, "startMapper", {
    enumerable: true,
    get: function get() {
        return _mappers.startMapper;
    }
});
Object.defineProperty(exports, "stopMapper", {
    enumerable: true,
    get: function get() {
        return _mappers.stopMapper;
    }
});
exports.subscribeForKeyboardEvents = subscribeForKeyboardEvents;
exports.unregisterEventHandler = unregisterEventHandler;
exports.unregisterSensor = unregisterSensor;
exports.unsubscribeFromKeyboardEvents = unsubscribeFromKeyboardEvents;
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _PlatformChecker = require("./PlatformChecker");
var _shareables = require("./shareables");
var _initializers = require("./initializers");
var _SensorContainer = require("./SensorContainer");
var _mappers = require("./mappers");
var _threads = require("./threads");
var _runtimes = require("./runtimes");
var _mutables = require("./mutables");
var isReanimated3 = exports.isReanimated3 = function isReanimated3() {
    return true;
};
var isConfigured = exports.isConfigured = isReanimated3;
global._WORKLET = false;
global._log = function(s) {
    console.log(s);
};
function getViewProp(viewTag, propName) {
    if (global._IS_FABRIC) {
        throw new Error("[Reanimated] `getViewProp` is not supported on Fabric yet.");
    }
    return new Promise(function(resolve, reject) {
        return _NativeReanimated.default.getViewProp(viewTag, propName, function(result) {
            if (typeof result === "string" && result.substr(0, 6) === "error:") {
                reject(result);
            } else {
                resolve(result);
            }
        });
    });
}
function getSensorContainer() {
    if (!global.__sensorContainer) {
        global.__sensorContainer = new _SensorContainer.SensorContainer();
    }
    return global.__sensorContainer;
}
var _worklet_10296548464238_init_data = {
    code: "function handleAndFlushAnimationFrame(eventTimestamp,event){const{eventHandler}=this.__closure;global.__frameTimestamp=eventTimestamp;eventHandler(event);global.__flushAnimationFrame(eventTimestamp);global.__frameTimestamp=undefined;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/core.ts",
    sourceMap: '{"version":3,"names":["handleAndFlushAnimationFrame","eventTimestamp","event","eventHandler","__closure","global","__frameTimestamp","__flushAnimationFrame","undefined"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/core.ts"],"mappings":"AAqFE,SAAAA,4BAASA,CAA6BC,cAAA,CAAsBC,KAAE,CAAQ,OAAAC,YAAA,OAAAC,SAAA,CAEpEC,MAAM,CAACC,gBAAgB,CAAGL,cAAc,CACxCE,YAAY,CAACD,KAAK,CAAC,CACnBG,MAAM,CAACE,qBAAqB,CAACN,cAAc,CAAC,CAC5CI,MAAM,CAACC,gBAAgB,CAAGE,SAAS,CACrC"}',
    version: "3.5.4"
};
function registerEventHandler(eventHandler, eventName) {
    var emitterReactTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    var handleAndFlushAnimationFrame = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var handleAndFlushAnimationFrame = function handleAndFlushAnimationFrame(eventTimestamp, event) {
            global.__frameTimestamp = eventTimestamp;
            eventHandler(event);
            global.__flushAnimationFrame(eventTimestamp);
            global.__frameTimestamp = undefined;
        };
        handleAndFlushAnimationFrame.__closure = {
            eventHandler: eventHandler
        };
        handleAndFlushAnimationFrame.__initData = _worklet_10296548464238_init_data;
        handleAndFlushAnimationFrame.__workletHash = 10296548464238;
        handleAndFlushAnimationFrame.__stackDetails = _e;
        return handleAndFlushAnimationFrame;
    }();
    return _NativeReanimated.default.registerEventHandler((0, _shareables.makeShareableCloneRecursive)(handleAndFlushAnimationFrame), eventName, emitterReactTag);
}
function unregisterEventHandler(id) {
    return _NativeReanimated.default.unregisterEventHandler(id);
}
var _worklet_17253714709332_init_data = {
    code: "function handleAndFlushAnimationFrame(state,height){const{eventHandler}=this.__closure;const now=performance.now();global.__frameTimestamp=now;eventHandler(state,height);global.__flushAnimationFrame(now);global.__frameTimestamp=undefined;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/core.ts",
    sourceMap: '{"version":3,"names":["handleAndFlushAnimationFrame","state","height","eventHandler","__closure","now","performance","global","__frameTimestamp","__flushAnimationFrame","undefined"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/core.ts"],"mappings":"AA2GE,SAAAA,6BAAAC,KAAA,CAAAC,MAAA,QAAAC,YAAA,OAAAC,SAAA,OAAAC,GAAA,CAAAC,WAAA,CAAAD,GAAA,GACAE,MAAA,CAAAC,gBAAA,CAAAH,GAAA,CACAF,YAAS,CAAAF,KAAA,CAAAC,MAAA,EAEPK,MAAM,CAAAE,qBAAsB,CAACJ,GAAA,EAC7BE,MAAM,CAACC,gBAAgB,CAAGE,SAAG,C"}',
    version: "3.5.4"
};
function subscribeForKeyboardEvents(eventHandler, options) {
    var _options$isStatusBarT;
    var handleAndFlushAnimationFrame = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var handleAndFlushAnimationFrame = function handleAndFlushAnimationFrame(state, height) {
            var now = performance.now();
            global.__frameTimestamp = now;
            eventHandler(state, height);
            global.__flushAnimationFrame(now);
            global.__frameTimestamp = undefined;
        };
        handleAndFlushAnimationFrame.__closure = {
            eventHandler: eventHandler
        };
        handleAndFlushAnimationFrame.__initData = _worklet_17253714709332_init_data;
        handleAndFlushAnimationFrame.__workletHash = 17253714709332;
        handleAndFlushAnimationFrame.__stackDetails = _e;
        return handleAndFlushAnimationFrame;
    }();
    return _NativeReanimated.default.subscribeForKeyboardEvents((0, _shareables.makeShareableCloneRecursive)(handleAndFlushAnimationFrame), (_options$isStatusBarT = options.isStatusBarTranslucentAndroid) != null ? _options$isStatusBarT : false);
}
function unsubscribeFromKeyboardEvents(listenerId) {
    return _NativeReanimated.default.unsubscribeFromKeyboardEvents(listenerId);
}
function registerSensor(sensorType, config, eventHandler) {
    var sensorContainer = getSensorContainer();
    return sensorContainer.registerSensor(sensorType, config, (0, _shareables.makeShareableCloneRecursive)(eventHandler));
}
function initializeSensor(sensorType, config) {
    var sensorContainer = getSensorContainer();
    return sensorContainer.initializeSensor(sensorType, config);
}
function unregisterSensor(sensorId) {
    var sensorContainer = getSensorContainer();
    return sensorContainer.unregisterSensor(sensorId);
}
if (!(0, _PlatformChecker.isWeb)()) {
    (0, _initializers.initializeUIRuntime)();
}
var featuresConfig = {
    enableLayoutAnimations: false,
    setByUser: false
};
function enableLayoutAnimations(flag) {
    var isCallByUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (isCallByUser) {
        featuresConfig = {
            enableLayoutAnimations: flag,
            setByUser: true
        };
        _NativeReanimated.default.enableLayoutAnimations(flag);
    } else if (!featuresConfig.setByUser && featuresConfig.enableLayoutAnimations !== flag) {
        featuresConfig.enableLayoutAnimations = flag;
        _NativeReanimated.default.enableLayoutAnimations(flag);
    }
}
function configureLayoutAnimations(viewTag, type, config) {
    var sharedTransitionTag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    _NativeReanimated.default.configureLayoutAnimation(viewTag, type, sharedTransitionTag, (0, _shareables.makeShareableCloneRecursive)(config));
}
function configureProps(uiProps, nativeProps) {
    if (!(0, _PlatformChecker.nativeShouldBeMock)()) {
        _NativeReanimated.default.configureProps(uiProps, nativeProps);
    }
}
